export default __webpack_public_path__ + "static/media/header.4225aaaa.png";